// extracted by mini-css-extract-plugin
export default {"headerCart":"HeaderCart_headerCart__2h-I+","icon":"HeaderCart_icon__pxM99","badge":"HeaderCart_badge__pCR5M","bump":"HeaderCart_bump__nbEmn"};